import * as React from "react";
const SvgArrow = props => <svg width={27} height={23} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M27 11.5 0 23V12.52l10.38-1.02L0 10.48V0l27 11.5Z" fill="currentColor" /></svg>;
export default SvgArrow;